// Lodash
import { get } from 'lodash';

// STORE ACTION AND STATE
import { Actions, ActionTypes } from './actions';
import { initialState, NewsFeedState } from './state';
import { Actions as AuthActions, ActionTypes as AuthActionTypes } from '../../auth/store/actions';


/**
 * This effect is for listen NewsFeed actions, execute auth service call and dispatch in NewsFeed reducer.
 * For NewsFeed api call purpose.
 *
 * @author Nirmal Jodhani <nirmal.jodhani@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 18/06/2020 (Nirmal Jodhani <nirmal.jodhani@saeculumsolutions.com>)  created NewsFeed reducer
 */
export function reducer(state = initialState, action: Actions | AuthActions): NewsFeedState {
  switch (action.type) {
    // NewsFeed COMMON METHOD
    case ActionTypes.NEWS_FEED_COMMON: {
      return state;
    }
    // NewsFeed Success COMMON METHOD
    case ActionTypes.NEWS_FEED_COMMON_SUCCESS: {
      // commonly store and handle all NewsFeed modules
      return {
        ...state,
        [action.response.common.STATE]: get(action.response.data, action.response.common.API_RESPONSE),
      };
    }


    // CLEAR_REDUCER METHOD ON LOGOUT
    case AuthActionTypes.CLEAR_REDUCER: {
      return initialState;
    }
    // CLEAR_BUSINESS_REDUCER METHOD ON BUSINESS CHANGE
    case AuthActionTypes.CLEAR_BUSINESS_REDUCER: {
      return initialState;
    }

    // DEFAULT
    default:
      return state;
  }
}
